import { AppShell, Box, Group, Menu, Text } from '@mantine/core'
import { useNavigate } from 'react-router-dom'
import { RoutePaths } from '@interfaces/routePaths'
import classes from './NavFooter.module.css'
import ExampleUser from '@assets/exampleUser.png'
import { IconChevronRight } from '@tabler/icons-react'

export interface NavFooterProps {
  color?: string
}

export const NavFooter = (props: NavFooterProps) => {
  const { color = 'dark' } = props
  const navigate = useNavigate()
  const isDark = color === 'dark'

  const handleAccountClick = () =>
    navigate(
      `${RoutePaths.ACCOUNT_SETTINGS}/${RoutePaths.ACCOUNT_SETTINGS_PERSONAL_INFO}`,
    )

  const handleAdminClick = () =>
    navigate(
      `${RoutePaths.ADMIN_SETTINGS}/${RoutePaths.ADMIN_SETTINGS_ACCOUNT}/${RoutePaths.ADMIN_SETTINGS_ACCOUNT_ORGANIZATION}`,
    )

  return (
    <AppShell.Section>
      <Menu
        position="right-end"
        shadow="md"
        offset={{ mainAxis: 3, crossAxis: -5 }}
      >
        <Menu.Target>
          <Box
            className={isDark ? classes.NavFooter : classes.NavFooter__light}
            p="xs"
          >
            <Group gap="sm" wrap="nowrap">
              <img
                className={classes.NavFooter__img}
                src={ExampleUser}
                width={45}
                height={45}
              />
              <Text
                size="sm"
                fw="bold"
                c={isDark ? 'white' : 'dark.4'}
                style={{ flexGrow: 1 }}
                truncate
              >
                Alfredo Carrillo
              </Text>
              <IconChevronRight
                color={
                  isDark
                    ? 'var(--mantine-color-navbar-blue-1)'
                    : 'var(--mantine-color-dark-5)'
                }
                size={28}
                stroke={1}
                style={{ flexShrink: 0 }}
              />
            </Group>
          </Box>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Label>Settings</Menu.Label>
          <Menu.Item onClick={handleAccountClick}>Account</Menu.Item>
          <Menu.Item onClick={handleAdminClick}>Administration</Menu.Item>
          <Menu.Divider />
          <Menu.Item color="red">Logout</Menu.Item>
        </Menu.Dropdown>
      </Menu>
    </AppShell.Section>
  )
}
